"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rates = void 0;
var rates = exports.rates = [{
  id: 1,
  value: 64,
  label: '64 Kbit/s Mono'
}, {
  id: 2,
  value: 40,
  label: '40 Kbit/s Mono'
}];